import type { AssetId, ProjectId } from 'owa-timestream-types';
import { ControlIcons } from 'owa-control-icons';
import { focusAsset } from 'owa-timestream-asset-sdk-actions/lib/actions';
import { resizeText } from './resizeAssetCommand.locstring.json';
import { showResizeHandles } from './actions';

export default function resizeAssetCommand(projectId: ProjectId, assetId: AssetId) {
    return {
        id: 'setElementResizing',
        iconName: ControlIcons.FullScreen,
        titleResourceId: resizeText,
        onInvoke: () => {
            focusAsset(projectId, assetId);
            showResizeHandles(assetId);
        },
    };
}
